import { useState } from 'react'
import { Box, Button, ButtonGroup, HStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom'
import { RosterView } from './recruit/RosterView'
import { RecruitView } from './recruit/RecruitView'
import { useLobbyDayAttendees } from '../../hooks/useLobbyDay'
import type { AddedAttendeeToken, LobbyDayStatus } from '../../types/lobbyDay'

interface AttendeesTabProps {
  eventId: string
  eventStatus: LobbyDayStatus
}

export function AttendeesTab({ eventId, eventStatus }: AttendeesTabProps) {
  const [view, setView] = useState<'recruit' | 'roster'>('recruit')
  // LW-24: show-once raw tokens minted by adds made during this Attendees-tab visit, carried
  // over to Roster so a freshly-added attendee's link is Copy-able there without a rotate.
  const [freshTokens, setFreshTokens] = useState<AddedAttendeeToken[]>([])
  const navigate = useNavigate()
  // Same query key RosterView reads (['lobby-day','attendees',eventId]) -- React Query dedupes
  // the fetch, so this costs nothing extra when Roster is mounted and stays in sync with
  // add/remove attendee mutations, which already invalidate that key.
  const { data: attendees } = useLobbyDayAttendees(eventId)
  const hasAttendees = !!attendees && attendees.length > 0

  return (
    <Box>
      <HStack justify="space-between" align="center" mb={4} flexWrap="wrap" gap={3}>
        <ButtonGroup size="sm" attached variant="outline">
          <Button
            colorPalette={view === 'roster' ? 'blue' : 'gray'}
            variant={view === 'roster' ? 'solid' : 'outline'}
            onClick={() => setView('roster')}
          >
            Roster
          </Button>
          <Button
            colorPalette={view === 'recruit' ? 'blue' : 'gray'}
            variant={view === 'recruit' ? 'solid' : 'outline'}
            onClick={() => setView('recruit')}
          >
            Recruit
          </Button>
        </ButtonGroup>
        <Button
          size="sm"
          variant="outline"
          disabled={!hasAttendees}
          onClick={() => {
            const returnTo = encodeURIComponent(`/dashboard/lobby-day/events/${eventId}?tab=attendees`)
            const returnLabel = encodeURIComponent('Lobby Day event')
            navigate(
              `/dashboard/communications/email/new?source=lobbyDayEvent&id=${eventId}&returnTo=${returnTo}&returnLabel=${returnLabel}`,
            )
          }}
        >
          ✉ Email attendees
        </Button>
      </HStack>

      {view === 'roster'
        ? <RosterView eventId={eventId} eventStatus={eventStatus} freshTokens={freshTokens} />
        : (
          <RecruitView
            eventId={eventId}
            onAttendeesAdded={(tokens) => setFreshTokens((prev) => [...prev, ...tokens])}
          />
        )}
    </Box>
  );
}
